import { render } from "./_CompanyAdmin.vue?vue&type=template&id=7caf96aa"
import script from "./_CompanyAdmin.vue?vue&type=script&lang=js"
export * from "./_CompanyAdmin.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\6217025534\\Desktop\\vsts-agent-win-x64-2\\_work\\60\\s\\WEPTW_Web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__